export enum CenterRouteRootSlugEnum {
  Login = 'login',
  BindMobile = 'bind-mobile',
  Registration = 'registration',
  RegistrationSuccess = 'success',
  RegistrationResultsWithType = 'results/:type',

  // 以下为移动端特有的（用于一些重定向相关）
  Wechat = 'wechat',
  WechatNew = 'wechat-new',
  WechatAuthorizeCallback = 'wechat-authCallback',
}

export enum CenterRouteWithUserSlugEnum {
  UserBase = 'user',

  ChangePhone = 'change-phone',
  Info = 'info',
}

export enum CenterRouteWithAidSlugEnum {
  ActivityBase = 'activity/:aid',

  Login = 'login',
  BindMobile = 'bind-mobile',
  Registration = 'registration',
  RegistrationSuccess = 'success',
  RegistrationResultsWithType = 'results/:type',
}
